import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";

export class UnmountPassengerDetailAction extends BaseAction<void, void> {

    override async run(): Promise<void | null> {
        try {
            updateRecoilState("passengerStateAtom", []);
            updateRecoilState("selectedPassengersPerTypeStateAtom", {});
            updateRecoilState("isAddShuttleAtom", false);
            // Flow-mode atoms (isHyperFastStateAtom, isQuickExchangeStateAtom,
            // isChangeDateStateAtom, isUpgradeToPremiumStateAtom,
            // isManageSeatingAtom) are intentionally NOT reset here. They
            // belong to the flow that set them; wiping them during the
            // AfterSaleBookingFlow cancel cascade broke the manage-seating
            // CheckoutPage.tsx:406/:413 guards. Reset happens in
            // SearchInitStep.ts:210-214 on new-session entry, and in each
            // flow's own Reset*Action on intentional exit.
            updateRecoilState("isAddShuttleFlowAtom", false);
            updateRecoilState("trainAtom", null);
            updateRecoilState("isBookReturnJourneyAtom", false);

            updateRecoilState("isMultiBookingStateAtom", false);

            //Update and Reset to Seating states
            updateRecoilState("selectedSeatsAtom", []);
            updateRecoilState("placeMapResponseAtom", null);
            updateRecoilState("coachLayoutResponseAtom", null);
            updateRecoilState("selectedCoachAtom", "");
            updateRecoilState("seatServiceClassAtom", []);
            updateRecoilState("seatTravelClassAtom", []);
            updateRecoilState("passengerSeatCursorAtom", []);
            updateRecoilState("unavailableSeatsAtom", []);
            updateRecoilState("initiallyAvailableSeatsAtom", null);
            updateRecoilState('offersRequestAtom', null);
            updateRecoilState("passengerSpecificationsTypesAtom", null);

            updateRecoilState("upgradeOutboundOffersAtom", []);
            updateRecoilState("upgradeInboundOffersAtom", []);

            updateRecoilState("paymentSuccessModalAtom", false);

            updateRecoilState("carLicensePlateAtom", "")

            updateRecoilState("saveCardAtom", false);

            // Reset addons related atoms
            updateRecoilState("addonsPassengerListAtom", []);
            updateRecoilState("confirmAddonsPassengerListAtom", []);
            updateRecoilState("carriedOverAddonsAtom", { outbound: [], inbound: [] });
        } catch (error) {
            console.error("Error in UnmountPassengerDetailAction:", error);
        }
    }
}

// Create a singleton instance
export const unmountPassengerDetailAction = new UnmountPassengerDetailAction(); 